import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {Button} from '../../../../../basic-ui-components/button/base/button.component';

export interface InfoPageButtonComponentProps {
  enabled: boolean;
  onOpenInfoPage: () => void;
}

@observer
export class InfoPageButtonComponent extends OrbitComponent<InfoPageButtonComponentProps> {

  render() {
    if(!this.props.enabled) {
      return null;
    }

    return (
      <Button
        preset="flatStroked"
        icon={{Component: this.services.theme.currentTheme.icons.infoIcon, size: "regular"}}
        className='cy-game-info-page-button'
        onClick={this.props.onOpenInfoPage}
        margin="0px 0px 0px 1em"
      />
    );
  }
}
